import { current } from '@reduxjs/toolkit';
import React, { useEffect, useRef, useState } from 'react';
import { container } from 'tsyringe';
import { UserService } from '../../services/user-service';

import './WelcomeTuto.scss';

interface WelcomeTutoProps {
  onAction: any;
}

const WelcomeTuto = (props: WelcomeTutoProps) => {

  const [userService] = useState(container.resolve(UserService));
  const firstName = userService.user ? (userService.user.firstName || userService.user.username) : '';

  const imgref0 = useRef();
  const imgref1 = useRef();

  const desc = {
    title: "Hello " + firstName + "<br/>Welcome to BlueJeans Studio!",
    bodies: [
      "Multistream to your social channels from anywhere to everywhere",
      "Brand your Livestream and build personal connection with the audience",
      "Control your event at your fingertips from anything to everything",
    ]
  }

  const [currentStep, setCurrentStep] = useState({ step: -1, title: desc.title, body: '', imgsrc0: '', imgsrc1: '' });

  useEffect(() => {
    onNext();
  }, [])


  const onNext = () => {
    if (currentStep.step < (desc.bodies.length - 1)) {
      const nstep = currentStep.step + 1;
      setCurrentStep({
        ...currentStep,
        step: nstep,
        body: desc.bodies[nstep],
        imgsrc0: `url(${process.env.PUBLIC_URL}/welcome/step${nstep}-0.jpg`,
        imgsrc1: `url(${process.env.PUBLIC_URL}/welcome/step${nstep}-1.jpg`,
      });
    }
  }
  const onPrev = () => {
    if (currentStep.step > 0) {
      const pstep = currentStep.step - 1;
      setCurrentStep({
        ...currentStep,
        step: pstep,
        body: desc.bodies[pstep],
        imgsrc0: `url(${process.env.PUBLIC_URL}/welcome/step${pstep}-0.jpg`,
        imgsrc1: `url(${process.env.PUBLIC_URL}/welcome/step${pstep}-1.jpg`,
      });
    }
  }

  const onSelectStep = (step) => {
    setCurrentStep({
      ...currentStep,
      step: step,
      body: desc.bodies[step],
      imgsrc0: `url(${process.env.PUBLIC_URL}/welcome/step${step}-0.jpg`,
      imgsrc1: `url(${process.env.PUBLIC_URL}/welcome/step${step}-1.jpg`,
    });
  }

  const onLater = () => {
    props.onAction('exit');
  }

  const onStartTour = () => {
    props.onAction('showTuto');
  }

  return (
    <div className='welcome-background'>
      <div className='welcome-container'>
        <div className='welcome-left'>
          <div className='welcome-logo'></div>
          <div className='welcome-title' dangerouslySetInnerHTML={{ __html: currentStep.title }}></div>
          <div className='welcome-body'>{currentStep.body}</div>
          <div className='welcome-steps'>
            {[0, 1, 2].map(s =>
              <div key={'step' + s} className={'welcome-steps-step ' + (currentStep.step === s ? 'welcome-steps-selected' : '')} onClick={() => onSelectStep(s)}></div>
            )}
          </div>
          <div className='welcome-footer'>
            {/* {currentStep.step == 1 &&
              <div className='welcome-btn welcome-btn-prev' onClick={onPrev}>PREVIOUS</div>
            } */}
            {currentStep.step < 2 &&
              <div className='welcome-btn welcome-btn-next' onClick={onNext}>NEXT</div>
            }
            {currentStep.step == 2 &&
              <>
                <div className='welcome-btn welcome-btn-next' onClick={onStartTour}>START A TOUR</div>
                <div className='welcome-btn welcome-btn-prev' onClick={onLater}>MAYBE LATER</div>
              </>
            }
          </div>
        </div>
        <div className='welcome-right'>
          <div className='welcome-frame'>
            <div className='welcome-pict welcome-pict0' style={{ backgroundImage: currentStep.imgsrc0 }} ref={imgref0}></div>
            <div className='welcome-pict welcome-pict1' style={{ backgroundImage: currentStep.imgsrc1 }} ref={imgref1}></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WelcomeTuto;